
interface TDSYNNEXLogoProps {
    white?: boolean;
}

export const TDSYNNEXLogo = ({ white }: TDSYNNEXLogoProps) => {
    const logoUrl = white 
        ? "/assets/images/TD_SYNNEX_Logo_WHT.png" 
        : "/assets/images/TD-SYNNEX-Synapse.png";

    return (
        <img 
            src={logoUrl} 
            alt="TD SYNNEX Synapse Logo" 
            style={{ width: '240px', maxWidth: '100%', height: 'auto' }} 
        />
    );
};
